import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserVendingMachine from 'src/games/VendingMachine/Main';

interface VendingMachineGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class VendingMachineGame extends React.Component<VendingMachineGameProps> {
    constructor(props: VendingMachineGameProps) {
        super(props);
        bindAllOfThis(this, VendingMachineGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserVendingMachine onComplete={this.completeGame}/>
        </div>;
    }
}

export default VendingMachineGame;



// WEBPACK FOOTER //
// ./src/pages/game/VendingMachineGame.tsx